<template>
<div id="catalogo_mt" >
    <v-power-catalogo :parametros="parametros" />
</div>
</template>

<script>
import powerCatalogo from "@/views/apendices/layout.vue";
export default {
    components: {
        "v-power-catalogo": powerCatalogo
    },
    mounted() {},

    data: () => ({
        fab: false,
        parametros: {
            url_actions: "apendices/",
            url_list: "apendices/lista/",
            tabla: 18,
            title: "RECINTOS FISCALIZADOS",
            columns: ["clave", "descripcion", "aduana", "actions"],
            options: {
                filterable: ["clave", "descripcion", "aduana"],
                sortable: ["clave", "descripcion", "aduana"],

                headings: {
                    clave: "Clave",
                    descripcion: "Descripción",
                    aduana: "Aduana",
                    actions: "Operaciones"
                }
            },
            camposexcel: {
                Clave: "clave",
                Descripción: "descripcion",
                Aduana: "aduana"
            },
            encabezadoLayout: {
                clave: "clave",
                descripcion: "descripcion",
                aduana: "aduana"
            },
            camposLayout: [{
                clave: "[Clave del Recinto]",
                descripcion: "[Descripción del Recinto]",
                aduana: "[Nombre de Aduana del Recinto]"
            }],
            model: {
                id: 0,
                clave: "",
                descripcion: "",
                aduana: ""
            },
            form: {
                clave: {
                    requiered: true,
                    label: "Clave",
                    value: "",
                    maxlen: 10
                },
                descripcion: {
                    requiered: true,
                    label: "Descripción",
                    value: "",
                    maxlen: 200
                },
                aduana: {
                    requiered: true,
                    label: "Aduana",
                    value: "",
                    maxlen: 200
                }
            },
            breadcrumbs: [{
                    text: "Inicio",
                    disabled: false,
                    to: "/home"
                },
                {
                    text: "Utilerías",
                    disabled: true,
                    to: ""
                },
                {
                    text: "Apendices",
                    disabled: true,
                    to: ""
                }
            ]
        }
    })
};
</script>
<style scoped>
.VueTables >>> thead th {
  white-space: normal !important;
}

.VueTables >>> tbody td{
  white-space: normal !important;
}
</style>